var React = require('react');

function IconClinicalBase (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_13625_1819)","key":0},React.createElement("path",{"d":"M6.8999 19.8004L10.1999 13.5004M8.3999 1.20038H15.5999V10.2004C15.5999 10.8004 21.5999 20.5804 21.5999 21.3004C21.5999 22.2004 20.9999 22.8004 11.9999 22.8004C2.9999 22.8004 2.3999 22.2004 2.3999 21.3004C2.3999 20.4004 8.3999 10.8004 8.3999 10.2004V1.20038Z","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_13625_1819"},React.createElement("rect",{"width":"24","height":"24","fill":"white","transform":"translate(0 0.000366211)"})))]);
}

IconClinicalBase.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconClinicalBase;

IconClinicalBase.default = IconClinicalBase;
